import React, { useMemo } from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import Typography from "@mui/material/Typography";
import TestForm from "../../../components/EditTestForm";
import Box from "@mui/material/Box";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Tests() {
  const testsColumns = useMemo(
    () => [
      {
        field: "name",
        headerName: "Test Name",
        width: 200,
      },
      {
        field: "test_location",
        headerName: "Location",
        width: 200,
      },
      {
        field: "english_order",
        headerName: "English Order",
        width: 200,
      },
      {
        field: "english_location",
        headerName: "English Location",
        width: 200,
      },
      {
        field: "english_answers",
        headerName: "English Answers",
        width: 400,
      },
      {
        field: "math_order",
        headerName: "Math Order",
        width: 200,
      },
      {
        field: "math_location",
        headerName: "Math Location",
        width: 200,
      },
      {
        field: "math_answers",
        headerName: "Math Answers",
        width: 400,
      },
      {
        field: "reading_order",
        headerName: "Reading Order",
        width: 200,
      },
      {
        field: "reading_location",
        headerName: "Reading Location",
        width: 200,
      },
      {
        field: "reading_answers",
        headerName: "Reading Answers",
        width: 400,
      },
      {
        field: "science_order",
        headerName: "Science Order",
        width: 200,
      },
      {
        field: "science_location",
        headerName: "Science Location",
        width: 200,
      },
      {
        field: "science_answers",
        headerName: "Science Answers",
        width: 400,
      },
      {
        field: "conversion_chart_link",
        headerName: "Conversion Chart Link",
        width: 400,
      },
    ],
    []
  );

  return (
    <>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
        }}
        size={12}
      >
        <ContentBox style={{ maxHeight: "85vh", height: "500rem" }}>
          <Typography variant="h5" fontWeight={"bold"}>
            Tests
          </Typography>
          <Box sx={{ height: "90%" }}>
            <PaginatedTable
              searchable
              tableName={"Tests"}
              addRowButtonText="Add Test"
              apiUrl={apiUrls.admin.tests()}
              columns={testsColumns}
              urlParams={{
                keep_related: "true",
              }}
              initialState={{
                pinnedColumns: {
                  right: ["actions"],
                },
              }}
              sortingMode={sortingModes.SERVER}
              disableCellFocus
              getRowTitle={({ row }) => row?.name}
              EditForm={TestForm}
              CreationForm={TestForm}
            />
          </Box>
        </ContentBox>
      </Grid>
    </>
  );
}
